import lb_logo from './LBMark.png'

type Props = {
  children?: ChildNode
}

export default function Navbar(props: Props) {
  return (
    <>
      <div className="navbar bg-customYellow text-black flex items-center justify-center">
        <div className="flex items-center">
          <img src={lb_logo} alt="csulb LB logo" className="h-12 w-10" />
          <h1 className="text-4xl text-pretty font-bold ml-4">Technology Help Desk Virtual Support</h1>
        </div>
      </div>
      {props.children}
    </>
  )
}